import React, { memo } from 'react'
import { Accordion, AccordionSummary, Typography, AccordionDetails, AccordionActions, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import GridBlock from './GridBlock';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Tr from 'translations/Translations';

const style = theme => ({
	title: {
	},
	highlighted: {
		color: theme.palette.primary.main,
	},
	titleGrid: {
		'&>*:last-child': {
			flexGrow: 1,
			marginLeft: theme.spacing(2),
		}
	},
	bottomButton: {
		width: "100%",
		height: theme.spacing(4),
		cursor: "pointer",
		paddingRight: theme.spacing(2),
		'&:hover': {
			background: theme.palette.background.appBarBackground,
		}
	},
	hide: {
		display: "none"
	}
})

function ExpansionPanel({
	panelRef,
	children,
	title,
	classes,
	expanded,
	onClick,
	onChange,
	defaultExpanded = false,
	highlighted = false,
	square,
	classesObj = {},
	disabled = false,
	titleAdornment,
	id,
	hide = false
}) {

	const onCollapse = () => {
		onChange(null, false)
	}

	return (
		<Accordion
			ref={panelRef}
			disabled={disabled}
			square={square}
			defaultExpanded={defaultExpanded}
			expanded={expanded}
			onChange={onChange}
			className={clsx(classesObj.root, {
				[classes.hide]: hide
			})}
			classes={{
				expanded: classesObj.expanded
			}}
			id={id}
		>
			<AccordionSummary
				classes={{
					expanded: classesObj.expandedSummary
				}}
				onClick={onClick}
				className={clsx(classesObj.title, {
					[classes.highlighted]: highlighted
				})}>
				<GridBlock
					justify='space-between'
					alignItems='center'
					className={clsx(classesObj.titleGrid, classes.titleGrid)}
				>
					{typeof title === "string" ?
						<Typography variant='h6'>
							{title}
						</Typography>
						: title}

					{titleAdornment}
				</GridBlock>
			</AccordionSummary>
			<AccordionDetails className={classesObj.details}>
				{children}
			</AccordionDetails>
			<AccordionActions>
				<GridBlock
					alignItems="flex-end"
					justify="flex-end"
					className={classes.bottomButton}
					onClick={onCollapse}
				>
					<Tooltip title={Tr('collapse')} placement='top'>
						<ExpandLessIcon />
					</Tooltip>
				</GridBlock>
			</AccordionActions>
		</Accordion>
	)
}

ExpansionPanel.propTypes = {
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object
	]),
	children: PropTypes.any,
	defaultExpanded: PropTypes.bool,
	expanded: PropTypes.bool,
	onClick: PropTypes.func,
	highlighted: PropTypes.bool,
	withPadding: PropTypes.bool,
	square: PropTypes.bool,
	panelRef: PropTypes.any
}

export default withStyles(style)(memo(ExpansionPanel));
